/**
 * Read a server error response when axios is using responseType:'blob'.
 * When the server returns an error (4xx/5xx), axios still gives us a Blob
 * instead of JSON. This helper reads it as text to surface the real error.
 */
export async function readBlobError(error) {
  if (error?.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      // Try to parse as JSON (our new error format)
      try {
        const json = JSON.parse(text);
        return json.error || json.detail || json.message || text.slice(0, 300);
      } catch {
        // Plain text error
        return text.slice(0, 300);
      }
    } catch {
      return error.message;
    }
  }
  // Standard axios error
  return error?.response?.data?.error
    || error?.response?.data?.detail
    || error?.message
    || 'Unknown error';
}

/**
 * Download a blob response as a file. Handles both success and error responses.
 * @param {object} res     - axios response with responseType:'blob'
 * @param {string} filename - download filename
 * @param {number} minSize  - minimum valid file size in bytes (default 50)
 */
export function triggerBlobDownload(res, filename, minSize = 50) {
  const blob = res.data; // already a Blob when responseType:'blob'
  if (blob.size < minSize) throw new Error('Empty file returned — no data for this period');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 1000);
}
